import { Injectable } from '@angular/core';
import { LoadingController, ToastController } from '@ionic/angular';
import { TranslocoService } from '@ngneat/transloco';
import * as moment from 'moment';
import { Browser } from '@capacitor/browser';

@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  constructor(
    private loadingController: LoadingController,
    private toastController: ToastController,
    private translationService: TranslocoService
  ) {}

  public openUrlInApp(url: string): void {
    Browser.open({ url: url });
  }

  public async createDefaultSpinner(): Promise<HTMLIonLoadingElement> {
    return this.loadingController.create({
      mode: 'md',
      cssClass: 'spinnerOnlyLoading',
      showBackdrop: false,
    });
  }

  public async showAppErrorToast(errorMessage: string) {
    const toast = await this.toastController.create({
      header: this.translationService.translate('validation.error'),
      message: errorMessage,
      duration: 3600,
      position: 'top',
      keyboardClose: true,
      mode: 'md',
      cssClass: 'error-toast',
    });
    await toast.present();
  }

  public async showErrorToast(error: any) {
    if (!error || !error?.error) {
      return;
    }

    const toast = await this.toastController.create({
      header: this.translationService.translate('validation.error'),
      message: error.error.komunikat,
      duration: 3600,
      position: 'top',
      keyboardClose: true,
      mode: 'md',
      cssClass: 'error-toast',
    });
    await toast.present();
  }

  public async showServerErrorToast() {
    const toast = await this.toastController.create({
      header: this.translationService.translate('validation.error'),
      message: this.translationService.translate('validation.serverError'),
      duration: 3600,
      position: 'top',
      keyboardClose: true,
      mode: 'md',
      cssClass: 'error-toast',
    });
    await toast.present();
  }

  public isDateInTheFuture(date: any): boolean {
    return moment(date).isAfter(moment());
  }

  public isDateInThePast(date: any): boolean {
    return moment(date).isBefore(moment());
  }
}
